import type { ICognitoStorage } from 'amazon-cognito-identity-js';

export default class TokensService {
  private readonly storage: ICognitoStorage;

  constructor(storage: ICognitoStorage) {
    this.storage = storage;
  }

  storeTokens(tokens: Record<string, string>): void {
    Object.entries(tokens).forEach(([key, value]) => {
      this.storage.setItem(key, value);
    });
  }
}
